module.exports = __webpack_public_path__ + "assets/img/kv-9d186924.jpg";